<template>
  <v-form v-model="valid" ref="form">
    <v-dialog overlay-opacity="0.7" v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('delete_emergency')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" @click="deleteComponent(detail)" :loading="loading">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="pt-3 container">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row>
            <v-col md="12">
              <v-card-title>
                <span class="headline">{{$t('emergency_contact_list')}}</span>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :loading="loading"
                  :headers="headers"
                  :items="contactList"
                  :hide-default-footer="true"
                  :no-data-text="$t('no_data')"
                >
                  <template v-slot:item.no="{index}">{{index+1}}</template>
                  <template v-slot:item.action="{item}">
                    <v-btn plain class="primary--text" @click="seeDetail(item)">{{$t('see_details')}}</v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-col>
            <v-col md="12" class="pt-0">
              <div class="sae-grey" @click="add">
                <v-icon class="ml-2">mdi-plus</v-icon>
                <span class="ml-4">{{$t('emergency_contact')}}</span>
              </div>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item>
          <v-row>
            <v-col md="6">
              <v-btn icon @click="tab = 0">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>{{$t('back')}}
            </v-col>
            <v-col md="6" class="text-right" v-if="isEdit">
              <v-btn icon @click="deleteItem(detail)" color="error">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
            <v-col md="12">
              <v-text-field
                :label="$t('name')"
                v-model="detail.name"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="12">
              <v-select
                 :label="$t('relationship')"
                v-model="detail.relationshipId"
                :rules="rules2"
                :items="relationList"
                item-text="nameId"
                item-value="id"
                required
                class="sae-required"
              ></v-select>
            </v-col>
            <v-col md="12">
              <v-text-field
                :label="$t('phoneNumber')"
                v-model="detail.phoneNumber"
                type="number"
                :rules="rules4"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="12">
              <v-textarea
                :label="$t('address')"
                v-model="detail.address"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                auto-grow
                rows="1"
                required
                class="sae-required"
              ></v-textarea>
            </v-col>
            <v-col md="12" class="text-center">
              <v-btn plain class="ma-2 primary--text" @click="tab = 0">{{$t('cancel')}}</v-btn>
              <v-btn
                color="primary"
                class="ma-2"
                :loading="loading"
                :disabled="!valid"
                @click="saveOrUpdate(detail)"
              >{{$t('save')}}</v-btn>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-form>
</template>

<script>
import moment from 'moment'

export default {
  props: ['userId', 'contactList'],
  name: "Emergency-Contact-List",
  data() {
    return {
      headers: [
        { text: "No", value: "no" },
        { text: this.$i18n.t('relation'), value: "relationship" },
        { text: this.$i18n.t('name'), value: "name" },
        { text: this.$i18n.t('phoneNumber'), value: "phoneNumber" },
        { text: "", value: "action" },
      ],
      rules: [(value) => (value === 0 ? true : !!value || this.$i18n.t('required'))],
      rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
      rules4: [
        v => /^[0-9.,]+$/.test(v) || this.$i18n.t('number_required'),
        (value) => (value === 0 ? true : !!value || this.$i18n.t('required'))
      ],
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      valid: false,
      formData: [],
      userIdLogin: this.$store.getters.user.id,
      loading: false,
      tab: 0,
      detail: {},
      isEdit: false,
      deleteDialog: false,
      relationList: [
        { id: 1, nameId: 'Suami' },
        { id: 2, nameId: 'Istri' },
        { id: 3, nameId: 'Ayah' },
        { id: 4, nameId: 'Ibu' },
        { id: 5, nameId: 'Anak Pertama' },
        { id: 6, nameId: 'Anak Kedua' },
        { id: 7, nameId: 'Anak Keempat' },
        { id: 8, nameId: 'Anak Kelima' },
      ],

    }
  },
  methods: {
    seeDetail(item) {
      this.isEdit = true
      this.detail = item
      this.tab = 1
    },
    add() {
      this.isEdit = false
      this.detail = { userId: this.userId, dateOfBirth: moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD') }
      this.tab = 1
    },
    costumHeader(actionId, action) {
      return { headers: { actionId, action } }
    },
    formatTime(date) {
      return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY")
    },
    getParentData() {
      this.formData = this.contactList
    },
    async getRelation() {
      this.loading = true
      this.relationList = await this.$store.dispatch('getRelations')
      this.loading = false
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      const body = { ...data, relationId: data.relationshipId}
      this.loading = true
      const result = await this.$store.dispatch('saveEmergency', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.$emit('reload', true)
        this.tab = 0
      }
    },
    async editComponent(data) {
      const body = { ...data, relationId: data.relationshipId }
      this.loading = true
      const result = await this.$store.dispatch('editEmergency', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.$emit('reload', true)
        this.tab = 0
      }
    },
    deleteItem() {
      this.deleteDialog = true;
    },
    async deleteComponent(data) {
      const body = { ...data, addressType: data.type }
      this.loading = true
      const result = await this.$store.dispatch('deleteEmergency', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_delete'))
        this.$emit('reload', true)
        this.tab = 0
        this.deleteDialog = false
      }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', {type, msg})
    },
    refreshData() {
      if (this.contactList) {
        this.formData = this.contactList
      } else {
        this.formData = []
        this.detail = { dateOfBirth: moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD') }
      }
    },
  },
  created() {
    this.getParentData()
    this.getRelation()
  },
  watch: {
    contactList() {
      this.formData = this.contactList
      this.tab = 0
      this.detail = {}
    },
    userId() {
      this.refreshData()
    },
    tab(tab) {
      if (this.$refs.form && !this.isEdit && tab == 1) {
        this.$refs.form.reset();
      }
    },
  }
}
</script>
<style scoped>
.sae-grey {
  background: #7c8a963d;
  line-height: 35px;
  cursor: pointer;
}
</style>